import React from "react";
import { UserMenu as RaUserMenu, MenuItemLink, UserMenuProps } from "react-admin";
import SettingsIcon from "@material-ui/icons/Settings";
import VpnKeyIcon from "@material-ui/icons/VpnKey";
import { useProfile } from "reactAdmin/resource/user/profileEdit";
import { useTranslation } from "react-i18next";

const UserMenu = (props: UserMenuProps) => {
    const { t } = useTranslation();
    const { profileVersion } = useProfile();

    return (
        <RaUserMenu key={profileVersion} {...props}>
            <MenuItemLink
                to="/profile"
                primaryText={t("menu.myProfile")}
                leftIcon={<SettingsIcon />}
            />
            <MenuItemLink
                to="/change-password"
                primaryText={t("menu.changePassword")}
                leftIcon={<VpnKeyIcon />}
            />
        </RaUserMenu>
    );
};

export default UserMenu;